import React from 'react'
import { FormComponent } from '../../../BaseComponent'
import IIntegrationSettings from '../../../../interfaces/IIntegrationSettings'
import { ConnectRequest, RetrieveTotalPetRequest, UpdateSettingsRequest, VerifyNetworkSettingsRequest } from '../../../../services/integration/interfaces/ApiRequest'
import { SpecieConsumer } from '../../../../context/SpecieContext'
import { ShelterProvider, ShelterConsumer } from '../../../../context/ShelterContext'

// Forms
import Auth from '../Auth'
import IIntegration from '../../../../interfaces/IIntegration'

export type RegisterNetworkProps = {
  authUuid?: string | null,
  integration?: IIntegration | null
  settings: IIntegrationSettings | null,
  total: number,
  error: any | null

  loading: boolean,
  history: any,

  verifySettings: (args: VerifyNetworkSettingsRequest) => Promise<any>,
  updateSettings: (args: UpdateSettingsRequest) => Promise<any>,

  retrieveTotalPet: (args: RetrieveTotalPetRequest) => Promise<any>,

  authPartner: (args: any) => Promise<any>,
  updateNetwork: (args: any) => Promise<any>,

  makeConnection: (args: ConnectRequest) => Promise<any>,
  closeModal: any,
  selectedItem:any
}

export default class RegisterNetworkForm extends FormComponent<RegisterNetworkProps> {

  state = {
    finish: false
  }

  private getCurrentStep = () => {
    const { authUuid } = this.props
    const { finish } = this.state

    if (!authUuid) return 0
    if (!finish) return 1

    return 2
  }


  render() {
    const {
      loading,
      history,
      error,
      authUuid,
      updateNetwork
    } = this.props

    const currentStep = this.getCurrentStep()

    return (
      <ShelterProvider>
        <ShelterConsumer>
          {({ fetching: fetchingShelter, shelters, requestShelterList }) => (
            <SpecieConsumer>
              {({ species, requestSpecieList }) => (
                <>

                  <div
                    style={{
                      display: currentStep === 0 ? 'unset' : 'none',
                      width: '100%'
                    }}
                  >
                    <Auth
                      authUuid={authUuid}
                      error={error}

                      shelters={shelters}

                      loading={loading}
                      contentLoading={fetchingShelter}
                      history={history}

                      loadShelters={requestShelterList}
                      authPartner={this.props.authPartner}
                      updateNetwork={updateNetwork}
                      closeModal={this.props.closeModal}
                      selectedItem={this.props.selectedItem}
                    />
                  </div>

                </>
              )}
            </SpecieConsumer>
          )}
        </ShelterConsumer>
      </ShelterProvider>
    )
  }
}
